/* RSI v2 · Planlegg – logikk fra Claude Design. Krever rsi-dc.js. */

class RSIP_planlegg extends DCLogic {
  renderVals() {
    
    return {};
  }
}

window.RSIP_planlegg = RSIP_planlegg;
